import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { paths } from '@app/constants';

@Component({
  selector: 'app-no-purchases',
  templateUrl: './no-purchases.component.html',
  styleUrls: ['./no-purchases.component.scss']
})
export class NoPurchasesComponent implements OnInit {
  constructor(private router: Router, ) { }

  ngOnInit() {
  }

  onClick() {
    this.router.navigate([paths.LIGHT_HOUSE_CHART], { replaceUrl: false });
  }
}
